import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { ZoomactivatepopupComponent } from './zoomactivatepopup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
      path: '',
      component: ZoomactivatepopupComponent,
      data: {
          title: 'Zoom Voucher popup'
      }
  }
];
@NgModule({
  declarations: [ZoomactivatepopupComponent],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    CommonModule,  
    FormsModule,  
    RouterModule.forChild(routes)
  ]
})
export class ZoomactivatepopupModule { }


